<template>
  <div>
    <PageHeader :title="title" />
    <div class="row" v-if="isLoading">
      <div class="col-md-3" v-for="no in 3" :key="no">
        <div width="10%" class="placeholder-glow">
          <span
            class="placeholder w-100 placeholder-lg"
            style="height: 140px"
          ></span>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-xl-3" v-for="(kiosk, index) in kioskPolicy" :key="index">
        <b-card no-body>
          <b-card-body>
            <b-card-title @click="editKiosk(kiosk.id)">
              <div class="d-flex justify-content-between">
                <h4 class="card-title">
                  {{ kiosk.kiosk_machine_number }}
                </h4>
                <i class="fas fa-pen text-primary ms-2" />
              </div>
            </b-card-title>
            <hr />
            <div class="d-flex">
              <h6>
                Active Code :
                <span class="text-primary">
                  {{ kiosk.kiosk_login_code }}
                </span>
                <i
                  class="fas fa-clone text-primary ms-2"
                  id="code"
                  v-b-popover.hover.bottom="'copy code'"
                  @click="copyCode(kiosk.kiosk_login_code)"
                />
                <i
                  v-if="!refreshCodeLoading"
                  class="fas fa-redo text-primary ms-2"
                  v-b-popover.hover.bottom="'Re-generate code'"
                  @click="refreshCode(kiosk.id)"
                />
                <i
                  v-else
                  class="bx bx-revision bx-spin toggle-right text-primary ms-2"
                />
              </h6>
            </div>
            <p class="m-1">
              Last Refresh :
              {{ global_format_date(kiosk.kiosk_code_refreshed_at) }}
            </p>
            <p class="m-1">
              Last login : {{ global_format_date(kiosk.last_login) }}
            </p>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import PageHeader from "@/components/page-header";
import Middleware from "@/helpers/middlewares";

export default {
  data() {
    return {
      title: "Kiosk Setting",
      kioskPolicy: [],
      isLoading: true,
      refreshCodeLoading: false,
    };
  },
  components: {
    PageHeader,
  },
  mounted() {
    this.getKioskPolicy();
  },
  methods: {
    //Method is used to get kiosk policy
    async getKioskPolicy() {
      await UserService.getKioskPolicyList()
        .then((kioskPolicy) => {
          this.isLoading = false;
          this.kioskPolicy = kioskPolicy;
        })
        .catch((error) => {
          this.isLoading = false;
          errorHandler(error);
        });
    },
    //Method kiosk policy
    copyCode(code) {
      Middleware.copyCode(code);
    },
    //Method is use for refresh kiosk login code
    async refreshCode(id) {
      this.refreshCodeLoading = true;
      await UserService.refreshKioskCode({ is_refresh_kiosk_code: true }, id)
        .then((response) => {
          this.kioskPolicy = this.kioskPolicy.map((item) => {
            if (item.id === response.id) {
              item = response;
            }
            return item;
          });
          this.refreshCodeLoading = false;
        })
        .catch((error) => {
          this.refreshCodeLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to redirect user
    editKiosk(kiosk_id) {
      this.$router.push(`/kiosk-machine-setting/${kiosk_id}`);
    },
  },
};
</script>
